import {
  ApiCreateUpdateComponentPayload,
  ApiSimpleComponent,
} from "@incendium/api";
import { personalisationService } from "Apis";

export const saveSharedComponentBlock = async (
  component: ApiSimpleComponent,
  token?: string
) => {
  const payload: ApiCreateUpdateComponentPayload = {
    ...component,
  };

  // Use externalId for shared blocks (MongoDB ObjectID string)
  const externalId = component?.externalId;
  const fn = externalId
    ? personalisationService.personalisationServiceUpdateSharedComponentBlock({
      componentId: externalId,
      payload,
      token,
    })
    : personalisationService.personalisationServiceCreateSharedComponentBlock({
      payload,
      token,
    });

  const res = await fn;
  return res;
};

export const readSharedComponentBlock = async (componentId: string) => {
  const res =
    await personalisationService.personalisationServiceReadSharedComponentBlock({
      componentId,
    });
  return res;
};

export const deleteSharedComponentBlock = async (
  componentId: string,
  token?: string
) => {
  const res =
    await personalisationService.personalisationServiceDeleteSharedComponentBlock(
      {
        componentId,
        token,
      }
    );
  return res;
};

